import {
  mapByAuthCode,
  mapByMessageIncludes,
  mapByPgCode,
  mapByStatus,
} from "./utils";

export const SUPABASE_AUTH_MESSAGE_MAPPING = [
  mapByAuthCode({
    invalid_credentials: {
      title: "invalidCredentials",
    },
    user_already_exists: {
      title: "userAlreadyExists",
    },
  }),
];

export const SUPABASE_PG_MESSAGE_MAPPING = [
  mapByPgCode({
    23505: { title: "uniqueViolation" },
    23503: { title: "foreignKeyViolation" },
    23502: { title: "notNullViolation" },
    P0101: { title: "oneLanguageViolation" },
    //23514: { title: "checkViolation" },
    //PGRST204: { title: "checkViolation" },
  }),
];

export const SUPABASE_STATUS_MESSAGE_MAPPING = [
  mapByStatus({
    429: {
      title: "rateLimited",
      level: "warning",
    },
  }),
];

export const SUPABASE_MESSAGE_INCLUDES_MAPPING = [
  // Message-includes mapping (prioritized; operation-aware)
  mapByMessageIncludes(
    /(?=.*violates foreign key constraint)(?=.*update or delete on table)/i,
    {
      title: "foreignKeyOnDelete",
    },
  ),
  mapByMessageIncludes(
    /(?=.*violates foreign key constraint)(?=.*insert or update on table)/i,
    {
      title: "foreignKeyOnWrite",
    },
  ),
  mapByMessageIncludes(/violates row-level security policy/i, {
    title: "forbidden",
  }),
  mapByMessageIncludes(/^forbidden$/i, {
    title: "forbidden",
  }),
  mapByMessageIncludes(/^unauthorized$/i, {
    title: "unauthorized",
  }),
  mapByMessageIncludes(/device_id is required/i, {
    title: "deviceIdRequired",
  }),
  mapByMessageIncludes(/invalid scope/i, {
    title: "invalidScope",
  }),
  mapByMessageIncludes(/duplicate key|unique constraint/i, {
    title: "uniqueViolation",
  }),
  mapByMessageIncludes(/failed to fetch|networkerror|network error/i, {
    title: "offline",
    level: "warning",
  }),
];
